//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import { initKtIcon } from "@/core/plugins/keenthemes";
import "@/core/plugins/prismjs";
import { Tooltip } from "bootstrap";
import ElementPlus from "element-plus";
import vi from 'element-plus/es/locale/lang/vi'

export default defineNuxtPlugin({
  name: "theme-init",
  enforce: "pre", // or 'post'
  async setup(nuxtApp) {
    // this is the equivalent of a normal functional plugin
    const app = nuxtApp.vueApp;

    app.use(ElementPlus, {
        locale: vi,
      });
    

    ApiService.init(app);
    initApexCharts(app);
    initInlineSvg(app);
    initKtIcon(app);
    initVeeValidate();
    app.directive("tooltip", (el) => {
      new Tooltip(el);
    });
  },
  hooks: {
    // You can directly register Nuxt app runtime hooks here
    "app:created"() {
      const nuxtApp = useNuxtApp();
      // do something in the hook
    },
  },
  env: {
    // Set this value to `false` if you don't want the plugin to run when rendering server-only or island components.
    islands: true,
  },
});
